import { rpx } from 'client/lib/rpx-client';
import dayjs from 'dayjs';

type Member = Awaited<
  ReturnType<typeof rpx.engagementRetention.getMemberSignals>
>['members'][number];

export function AipMemberRow(props: {
  member: Member;
  actionLabel: string;
  onOpen: (m: Member) => void;
  onAction: (m: Member) => void;
}) {
  const m = props.member;
  const last = m.lastCallAttendedAt ? dayjs(m.lastCallAttendedAt).fromNow() : 'never';
  return (
    <div class="flex items-baseline justify-between gap-3 border-t border-gray-200 py-2 first:border-t-0 first:pt-0">
      <button
        type="button"
        class="flex min-w-0 items-center gap-1.5 text-left text-sm text-indigo-700 hover:underline"
        onClick={() => props.onOpen(m)}
      >
        <span class="truncate">{m.name || m.email}</span>
        {m.membershipSource === 'invited' && (
          <span class="shrink-0 rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600">
            Invited
          </span>
        )}
      </button>
      <span class="shrink-0 text-xs text-gray-500">
        {m.callsAttended} calls · last {last}
      </span>
      <button
        type="button"
        class="shrink-0 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
        onClick={() => props.onAction(m)}
      >
        {props.actionLabel}
      </button>
    </div>
  );
}
